import React from 'react';
import PropTypes from 'prop-types';

function ImageIcon({ color = 'black', width = 16, height = 16, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.16667 7.25L3.83333 5.58333L8.41667 10.1667L11.3333 7.25L13.8333 9.75V2.16667H2.16667V7.25ZM2.16667 9.6075V13.8333H4.75L7.23833 11.3458L3.83333 7.94083L2.16667 9.6075ZM7.1075 13.8333H13.8333V12.1075L11.3333 9.6075L7.1075 13.8333ZM1.33333 0.5H14.6667C14.8877 0.5 15.0996 0.587797 15.2559 0.744078C15.4122 0.900358 15.5 1.11232 15.5 1.33333V14.6667C15.5 14.8877 15.4122 15.0996 15.2559 15.2559C15.0996 15.4122 14.8877 15.5 14.6667 15.5H1.33333C1.11232 15.5 0.900358 15.4122 0.744078 15.2559C0.587797 15.0996 0.5 14.8877 0.5 14.6667V1.33333C0.5 1.11232 0.587797 0.900358 0.744078 0.744078C0.900358 0.587797 1.11232 0.5 1.33333 0.5ZM10.9167 6.33333C10.5851 6.33333 10.2672 6.20164 10.0328 5.96722C9.79836 5.7328 9.66667 5.41485 9.66667 5.08333C9.66667 4.75181 9.79836 4.43387 10.0328 4.19945C10.2672 3.96503 10.5851 3.83333 10.9167 3.83333C11.2482 3.83333 11.5661 3.96503 11.8005 4.19945C12.035 4.43387 12.1667 4.75181 12.1667 5.08333C12.1667 5.41485 12.035 5.7328 11.8005 5.96722C11.5661 6.20164 11.2482 6.33333 10.9167 6.33333Z"
        fill={color}
      />
    </svg>
  );
}

ImageIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default ImageIcon;
